import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminSignatures = lazy(() => import("@/pages/admin/AdminSignatures"));

export const Route = createFileRoute("/admin/arenden/signaturer")({
  head: () => ({ meta: [{ title: "Signaturer – Adminpanel" }] }),
  component: AdminSignatures,
});
